import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { MyTransactionMethodsComponent } from './my-transaction-methods.component';


@NgModule({
  declarations: [
    MyTransactionMethodsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class MyTransactionMethodsModule {}